import React from 'react';
import { useLocation } from 'react-router-dom';
import Invoice from '../components/Invoice/Invoice';

const PrintInvoicePage: React.FC = () => {
    const location = useLocation();
    const order = location.state?.order;

    if (!order) return <div>No order selected for printing.</div>;

    return <Invoice order={order} />;
};

export default PrintInvoicePage;
